import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/** Code-drawn cover in the product look: chalk page, colour band, hanging hoop line-art. */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-coral',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  return <div className={`relative aspect-[3/4] overflow-hidden rounded-[10px] bg-cloud shadow-book ${className}`} data-id="element-43" data-mp="2o5wt8ixfxpwm">
      <span className={`absolute inset-x-0 top-0 h-[22%] ${accent}`} aria-hidden="true" data-id="element-44" data-mp="2jdwyr6053p7f" />
      <svg viewBox="0 0 120 70" className="absolute bottom-[6%] left-[10%] w-[80%]" aria-hidden="true" data-id="element-45" data-mp="2ef24n7wq2e80">
        <line x1="60" y1="0" x2="60" y2="14" stroke="#6B6470" strokeWidth="1.2" data-id="element-46" data-mp="29htm367nw868" />
        <circle cx="60" cy="38" r="22" stroke="#2F6F7A" strokeWidth="2.4" fill="none" data-id="element-47" data-mp="24i798xvqwtxy" />
        <circle cx="57" cy="36" r="2.6" fill="#2B1B3A" data-id="element-48" data-mp="20gcd07so96r1" />
        <path d="M58 39 L60 50 M59 42 L70 28 M60 50 L74 56 M60 50 L54 60" stroke="#2B1B3A" strokeWidth="1.4" strokeLinecap="round" fill="none" data-id="element-49" data-mp="20gvs7gqxth1d" />
      </svg>
      <div className="relative flex h-full flex-col px-[11%] pt-[30%]" data-id="element-50" data-mp="1e1rb4ec9o7w5">
        <p className={`font-sans font-bold uppercase tracking-[0.18em] text-slate ${sm ? 'text-[7px]' : 'text-[9px]'}`} data-id="element-51" data-mp="zclft1gjv1tj">
          {kicker}
        </p>
        {number && <p className={`mt-1 font-display font-bold leading-none text-cloud-dark ${sm ? 'text-3xl' : 'text-5xl'}`} data-id="element-52" data-mp="149ljx6tu9ui0">{number}</p>}
        <p className={`mt-2 font-display font-bold leading-[1.02] tracking-tight text-ink ${sm ? 'text-[13px]' : 'text-[19px]'}`} data-id="element-53" data-mp="1x03okca7o3xj">
          {title}
        </p>
        <p className={`mt-2 font-semibold uppercase tracking-widest text-slate-soft ${sm ? 'text-[5.5px]' : 'text-[7px]'}`} data-id="element-54" data-mp="1j2nduokvtnzz">
          Aerial Class Ready
        </p>
      </div>
    </div>;
}